import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addCapacityAssessmentRating } from "common/services/capacity-assessments.service";
import Form from "./Form";
import { toast } from "react-toastify";

const AddCapacityAssessmentRatings: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
}> = ({ toggle, isModalOpen, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);
  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      capacityAssessmentType: {
        value: "",
        label: "",
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      capacityAssessmentType: Yup.object().shape({
        value: Yup.number().required("Please select type of assessment"),
      }),
    }),
    onSubmit: async (values: any) => {
      const data = {
        data: {
          name: values["name"],
          capacityAssessmentType: values.capacityAssessmentType.value,
        },
      };

      setLoading(true);
      try {
        await addCapacityAssessmentRating(data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Capacity assessment rating added successfully", {});
      } catch (e: any) {
        toast.error("Capacity assessment rating creation failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Capacity Assessment Rating
      </ModalHeader>

      <Form
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default AddCapacityAssessmentRatings;
